import { tenants } from "../../config/tenants.js";
import type { Post } from "../Post.js";
import { getPostsListingPath } from "./getPostsListingPath.js";

export function getPostDetailPath(post: Pick<Post, "locale" | "urlSlug">): string {
	const tenant = tenants[post.locale];
	return `${getPostsListingPath(tenant)}/${post.urlSlug}`;
}
